import { render, staticRenderFns } from "./rest-imot-list.vue?vue&type=template&id=38fccc7a"
import script from "./rest-imot-list.vue?vue&type=script&lang=js"
export * from "./rest-imot-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports